<template>
  <div id="app">
    <v-app id="inspire">
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card v-model="show" color="#FFFF99">
          <v-card-title>
            <v-icon large left>mdi-excavator</v-icon>
            Obra - CRONOGRAMA
          </v-card-title>
          <v-card-text class="pt-2">
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-select v-model="select" :items="obras" item-text="nombre" item-value="codigo" label="Obras"
                  return-object single-line menu-props="auto" hide-details required dense></v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4" md="4">
                <h6>Cliente: {{ select.cliente }}</h6>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <h6>Comitente: {{ select.comitente }}</h6>
              </v-col>
              <v-col cols="6" sm="3" md="3">
                <h6>Código: {{ select.codigo }}</h6>
              </v-col>
              <v-col cols="6" sm="2" md="2">
                <v-btn class="mx-2" fab dark color="teal" @click="verGrafico(select.codigo)">
                  <v-icon dark>
                    mdi-chart-line
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card>
          <v-data-table :headers="headers" :items="cronograma" locale="es-ar" class="elevation-1" :items-per-page="10"
            :footer-props="{
              itemsPerPageText: 'Tareas por página',
            }">
            <template v-slot:item.tarea="{ item }">
              <v-chip :color="getColor(item.fechainicio, item.fechafin, item.porcentaje)
                " dark>
                {{ item.tarea }}
              </v-chip>
            </template>
            <template v-slot:item.porcfecha="{ item }">
              <v-chip :color="getAvance(item.fechainicio, item.fechafin, item.porcentaje)
                " dark>
                {{ cronograma.porcfecha }} %
              </v-chip>
            </template>
          </v-data-table>
          <VerGrafico :visible="showGrafico" :codigo="codigoobra" :labels="labels" :labelsA="labelsA"
            :cronogramas="cronogramas" :avancecronogramas="avancecronogramas" :obra="select.nombre"
            @close="showGrafico = false"></VerGrafico>
        </v-card>
      </v-form>
    </v-app>
  </div>
</template>

<script>
import moment from "moment";
import axios from "../../axios-auth";
import VerGrafico from "../Graficos/Cronograma.vue";
export default {
  components: { VerGrafico },
  data: (vm) => ({
    showGrafico: false,
    usuario: "",
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    numberRule: [
      (v) => v.length > 1 || "2 digitos",
      (v) => v <= 31 || "El valor debe ser menor a 31",
    ],
    select: "",
    codigoobra: "",
    obras: [],
    Codigo: "",
    Nombre: "",
    cronograma: [],
    labels: [],
    labelsA: [],
    cronogramas: [],
    avancecronogramas: [],
    //item: "",
    porcentajeavance: "-",
    headers: [
      { text: "Tarea", value: "tarea", sortable: false },
      { text: "% Cumplido", value: "porcentaje", sortable: true },
      { text: "% a la fecha", value: "porcfecha", sortable: true },
      {
        text: "Fecha Inicio",
        value: "fechainicio",
        sortable: true,
      },
      { text: "Fecha Final", value: "fechafin", sortable: false },
    ],
  }),
  watch: {
    select: function (val) {
      this.codigo = this.select.codigo;
      // this.labels = [];
      // this.cronogramas = [];
      this.asignarvalor();
      this.cargarvalores();
    },
  },
  computed: {
    show: {
      get() {
        //this.mostrar = true;
        //this.resptrabajo = this.$store.state.nombre.toString().trim();
        this.cargarObras();
        // return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarListado();
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    verGrafico(codigo) {
      this.codigoobra = codigo;
      this.showGrafico = true;
    },

    getColor(fechai, fechaf, porcentaje) {
      var Hoy = moment().format("DD/MM/YYYY");
      if (
        porcentaje != "100" &&
        moment(fechaf, "DD/MM/YYYY")
          .fromNow()
          .includes("ago")
      )
        return "red";
      // else if (calories > 200) return 'orange'
      else return "green";
    },
    getAvance(fechai, fechaf, porcentaje) {
      var dias1 = moment().diff(moment(fechai, "DD/MM/YYYY"), "days");
      var dias2 = moment().diff(moment(fechaf, "DD/MM/YYYY"), "days");
      var avance =
        moment(fechaf, "DD/MM/YYYY").diff(
          moment(fechai, "DD/MM/YYYY"),
          "days"
        ) + 1;
      if (dias1 <= 0) {
        this.cronograma.porcfecha = "0";
      } else if (dias2 >= 0) {
        this.cronograma.porcfecha = "100";
      } else {
        this.cronograma.porcfecha = Math.round((dias1 * 100) / avance, 2);
      }
      // console.log(
      //   "diferencia DIAS Inicio: " +
      //     dias1 +
      //     "diferencia DIAS Final: " +
      //     dias2 +
      //     " AVANCE: " +
      //     avance
      // );

      if ((dias1 * 100) / avance > porcentaje && porcentaje != "100") return "red";
      // if (
      //   porcentaje != "100" &&
      //   moment(fecha, "DD/MM/YYYY")
      //     .fromNow()
      //     .includes("ago")
      // )
      //   return "red";
      // else if (calories > 200) return 'orange'
      else return "green";
    },

    asignarvalor() {
      console.log("PASO POR ACA");
      const codigoobra = this.select.codigo;
      let self = this;
      axios
        .get("/Obras/CargarListadoCronograma?", {
          params: {
            codigo: codigoobra,
          },
        })
        .then((response) => {
          self.cronograma = response.data;
        })
        .catch((error) => {
          self.cronograma = [];
          console.log(error);
        });
    },
    cargarvalores() {
      console.log("LLEGA ESTE CODIGO: " + this.codigo);
      //   console.log("codigo" + this.codigo);
      const codigoobra = this.codigo;
      let self = this;
      self.labels.splice(0);
      self.labelsA.splice(0);
      self.cronogramas.splice(0);
      self.avancecronogramas.splice(0);
      axios
        .get("/Obras/CargarGraficoCronograma?", {
          params: {
            codigo: codigoobra,
          },
        })
        .then((response) => {
          response.data.forEach((element) => {
            self.labels.push(element.fechafin);
            self.cronogramas.push(element.porcentaje);
            //   self.avancecronogramas.push(element.avance);
          });
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get("/Obras/CargarGraficoAvance?", {
          params: {
            codigo: codigoobra,
          },
        })
        .then((response) => {
          response.data.forEach((element) => {
            self.labelsA.push(element.fechafin);
            // self.cronogramas.push(element.porcentaje);
            self.avancecronogramas.push(element.avance);
          });
        })
        .catch((error) => {
          console.log(error);
        });
      console.log(this.avancecronogramas)
    },
    cargarObras() {
      let self = this;
      axios
        .get("/Obras/GetObrasPA", {
          params: {
            estado: "P",
            filtro: "",
          },
        })
        .then((response) => {
          self.obras = response.data;
          self.responsable = self.$store.state.nombre.toString().trim();
        })
        .catch((error) => {
          self.obras = [];
        });
    },

    vaciarListado() {
      this.cronograma = [];
      this.cronog = [];
    },
  },
};
</script>
